import {
    actionTypes as DataActionTypes,
    actions as DataActions,
    reducerArray as DataReducerArray,
    selectors as DataSelectors
} from './Data/index';

import {
    actionTypes as UIActionTypes,
    actions as UIActions,
    reducerArray as UIReducerArray,
    selectors as UISelectors
} from './UI/index';

import {
    actionTypes as SystemActionTypes,
    actions as SystemActions,
    reducer as SystemReducer
} from './System';

import {
    reducer as RouterReducer,
    selectors as RouterSelectors
} from './Router';

export const actionTypes = {
    Data: DataActionTypes,
    UI: UIActionTypes,
    System: SystemActionTypes
};

export const actions = {
    Data: DataActions,
    UI: UIActions,
    System: SystemActions
};

export const reducerArray = [
    // IMPORTANT: DataReducer must be first in Array, TODO: system.boot after system.init to make sure the state was initialized
    ...DataReducerArray,
    ...UIReducerArray,
    SystemReducer,
    RouterReducer
];
export const selectors = {
    Data: DataSelectors,
    UI: UISelectors,
    Router: RouterSelectors
};